<app-breadcrumb *ngIf="!embeddedView" [master]="'Rozliczenia'" [parentName]="'Raporty TU'" [name]="'Prowizje'"></app-breadcrumb>
<div class="commission-import-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="commission-import-list-filters">
    <app-month-picker
      *ngIf="enableFilters === null || enableFilters.includes('billingMonth')"
      class="commission-import-list-filter"
      label="Miesiąc rozliczeniowy" [required]="false"
      name="billingMonth" [(ngModel)]="initialFilters.billingMonth"
    ></app-month-picker>

    <app-dict-insurance-companies
      *ngIf="enableFilters === null || enableFilters.includes('insuranceCompany')"
      [multiple]="true" label="TU"
      class="commission-import-list-filter"
      [(ngModel)]="initialFilters.in$insuranceCompany" name="in$insuranceCompany"
      (selectedInsuranceCompanies)="selectedInsuranceCompanies = $event"
    ></app-dict-insurance-companies>

    <app-dict
      *ngIf="enableFilters === null || enableFilters.includes('importer')"
      [multiple]="true" label="Importer"
      class="commission-import-list-filter"
      [dictType]="'commission_importer_' + (selectedInsuranceCompanies.length > 0 ? selectedInsuranceCompanies[0].key : '')"
      [(ngModel)]="initialFilters.importer" name="importer"
    ></app-dict>

    <mat-form-field
      *ngIf="enableFilters === null || enableFilters.includes('policyNumber')"
      class="commission-import-list-filter"
      matTooltip="Dodaj &quot;%&quot; na początku numeru, aby wyszkiwać prowizję, która zawiera daną frazę. Użyj &quot;_&quot; jeśli dotyczy to tylko jednego znaku."
      matTooltipPosition="above"
    >
      <mat-label>Numer polisy</mat-label>
      <input matInput placeholder="Numer polisy" name="containsFromLeft$policyNumber" [(ngModel)]="initialFilters.containsFromLeft$policyNumber">
    </mat-form-field>

    <app-dict
      *ngIf="enableFilters === null || enableFilters.includes('company')"
      [multiple]="false" label="Firma"
      class="commission-import-list-filter"
      dictType="company"
      [(ngModel)]="initialFilters.company" name="company"
    ></app-dict>

    <app-dict-ofwcas
      *ngIf="enableFilters === null || enableFilters.includes('ofwca')"
      [multiple]="false" label="OFWCA"
      class="commission-import-list-filter"
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
    ></app-dict-ofwcas>

    <app-dict-partners
      *ngIf="enableFilters === null || enableFilters.includes('partner')"
      [multiple]="false" label="Partner"
      class="commission-import-list-filter"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <mat-form-field
      class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('collection')"
    >
      <mat-label>Inkaso od</mat-label>
      <input matInput placeholder="Inkaso od" name="gte$collection" [(ngModel)]="initialFilters.gte$collection">
    </mat-form-field>

    <mat-form-field
      class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('collection')"
    >
      <mat-label>Inkaso do</mat-label>
      <input matInput placeholder="Inkaso do" name="lte$collection" [(ngModel)]="initialFilters.lte$collection">
    </mat-form-field>

    <app-dict-regionals
      *ngIf="enableFilters === null || enableFilters.includes('partnerAssetsRegional')"
      [multiple]="false" label="Regionalny majątek (Partner)"
      class="commission-import-list-filter"
      [(ngModel)]="initialFilters.partnerAssetsRegional" name="partnerAssetsRegional"
    ></app-dict-regionals>

    <app-dict-regionals
      *ngIf="enableFilters === null || enableFilters.includes('ofwcaAssetsRegional')"
      [multiple]="false" label="Regionalny majątek (OFWCA)"
      class="commission-import-list-filter"
      [(ngModel)]="initialFilters.ofwcaAssetsRegional" name="ofwcaAssetsRegional"
    ></app-dict-regionals>

    <mat-form-field
      appearance="standard" class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('notMatched')"
    >
      <mat-label>Nieprzypisane</mat-label>
      <mat-select
        [(ngModel)]="initialFilters.notMatched" name="notMatched"
        [multiple]="true"
      >
        <mat-option [value]="'ofwca'">OFWCA</mat-option>
        <mat-option [value]="'risk'">Ryzyko ASF</mat-option>
        <mat-option [value]="'registration'">Rejestracja</mat-option>
        <mat-option [value]="'contract'">Umowa</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      appearance="standard" class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('matched')"
    >
      <mat-label>Przypisane</mat-label>
      <mat-select
        [(ngModel)]="initialFilters.matched" name="matched"
        [multiple]="true"
      >
        <mat-option [value]="'ofwca'">OFWCA</mat-option>
        <mat-option [value]="'risk'">Ryzyko ASF</mat-option>
        <mat-option [value]="'registration'">Rejestracja</mat-option>
        <mat-option [value]="'contract'">Umowa</mat-option>
      </mat-select>
    </mat-form-field>

    <app-dict-all-contracts
      *ngIf="enableFilters === null || enableFilters.includes('contract')"
      [multiple]="false"
      label="Umowa" class="commission-import-list-filter"
      [(ngModel)]="initialFilters.contract"
      name="contract"
    ></app-dict-all-contracts>

    <app-datepicker
      *ngIf="enableFilters === null || enableFilters.includes('createdAt')"
      class="commission-import-list-filter"
      label="Data importu od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      *ngIf="enableFilters === null || enableFilters.includes('createdAt')"
      class="commission-import-list-filter"
      label="Data importu do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <app-dict
      *ngIf="enableFilters === null || enableFilters.includes('risk')"
      [multiple]="false" label="Ryzyko ASF"
      class="commission-import-list-filter"
      dictType="internal_risk"
      [(ngModel)]="initialFilters.risk" name="risk"
    ></app-dict>

    <app-dict
      *ngIf="enableFilters === null || enableFilters.includes('status')"
      [multiple]="true" label="Status"
      class="commission-import-list-filter"
      dictType="commission_import_row_status"
      [(ngModel)]="initialFilters.in$status" name="in$status"
    ></app-dict>
  </form>

  <div class="commission-import-list-buttons">
    <button *ngIf="(userPermissions | async).settlement.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).settlement.read_report || loadingData"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" [disabled]="loadingData" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" [disabled]="loadingData" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="rows" matSort (matSortChange)="sortChanged($event)">
    <ng-container matColumnDef="billingMonth">
      <th mat-header-cell *matHeaderCellDef> Miesiąc rozliczeniowy </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/rozliczenia/szczegoly', element?.settlement?.uuid]">
          {{element.settlement?.billingMonth}} -
          <ng-container *ngIf="element.partner">
            {{element.settlement?.partner?.shortName}}
          </ng-container>

          <ng-container *ngIf="element.ofwca">
            {{element.settlement?.ofwca?.fullName}}
          </ng-container>
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="insuranceCompany"> TU <br> (Importer) </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.insuranceCompany" class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">
          {{element.insuranceCompany.name}}
          <ng-container *ngIf="element.import?.importer">
            <br>({{element.import?.importer?.name}})
          </ng-container>
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="ofwca"> OFWCA </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.ofwca" class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca.uuid]">{{element.ofwca.fullNameReversed}}</a>
        <ng-container *ngIf="!element.ofwca">
          {{element?.ofwcaIdType?.name}}: {{element.ofwcaIdNumber}}
          <br>{{element.ofwcaFullName}}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="contract">
      <th mat-header-cell *matHeaderCellDef> Umowa </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.contract" class="default-link" [routerLink]="['/umowy/szczegoly', element.contract?.uuid]">{{element.contract?.number}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="policyNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="policyNumber"> Numer polisy </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/raporty-tu/prowizje/szczegoly', element.uuid]">
          {{element.policyNumber ? element.policyNumber : 'Brak numeru'}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="collection">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="collection"> Inkaso </th>
      <td mat-cell *matCellDef="let element">
        {{element.collection | number:'1.2-2'}} zł
      </td>
    </ng-container>

    <ng-container matColumnDef="rate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="rate">
        Stawka % TU/Partner
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="null !== element.importRate">{{element.importRate | number:'1.2-2'}}%</ng-container>
        <ng-container *ngIf="null === element.importRate">{{element.rate | number:'1.2-2'}}%</ng-container>
        <ng-container *ngIf="null !== element.ratePaid">/{{element.ratePaid | number:'1.2-2'}}%</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="commission">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="commission">
        Prowizja zł TU/Partner
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container>{{(element.commission != 0 ? element.commission : 0) | number:'1.2-2'}} zł</ng-container>
        <ng-container *ngIf="element.commissionPaid !== null">/{{element.commissionPaid | number:'1.2-2'}} zł</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="internalRisk">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="risk"> Ryzyko ASF </th>
      <td mat-cell *matCellDef="let element">
        {{element.risk?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="partner"> Partner </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.partner" class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{element.partner.shortName ? element.partner.shortName : "\<\brak nazwy\>"}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="partnerAssetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny majątek (Partner) </th>
      <td mat-cell *matCellDef="let element">
        {{element.partnerAssetsRegional?.fullName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
          {{element.status.name}}
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [disabled]="loadingData" [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
